// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Armenia from '../_raw/flag/icon_flag_armenia.png';

export default () => <img src={Armenia} alt="Armenia" />;
